/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState, useEffect, useRef } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { CaseChart } from 'components/caseChart'
import { AllCases } from 'components/allCases'
import { SwissCasesTable } from 'components/swissCasesTable'
import Toggle from 'react-toggle'
import csvjson from 'csvjson'
import { group } from 'd3-array'

const showAverage = true
export function AppComponent() {
  const [showHosp, setShowHosp] = useState<boolean>(false)
  const [dailyNew, setDailyNew] = useState<dataObject[] | undefined>(undefined)
  const [date, setDate] = useState(new Date().toLocaleString())
  //
  const [tableData, setTableData] = useState<tableData[] | undefined>()
  const [chSum, setCHsum] = useState<sumData | undefined>()
  const [charts, setCharts] = useState<chartData[] | undefined>()

  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/cantons-overview.json'
    )
      .then(response => {
        return response.json()
      })
      .then(jsondata => {
        setCHsum({
          cases: jsondata.reduce((a, b) => a + +b.cases, 0),
          death: jsondata.reduce((a, b) => a + +b.death, 0)
        })
        setTableData(jsondata)
      })

    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard/switzerland-daily.csv'
    )
      .then(response => {
        return response.text()
      })
      .then(csv => csvjson.toObject(csv, {}))
      .then(jsondata => {
        setCharts(jsondata)
        setDate(
          new Date(jsondata[jsondata.length - 1].date).toLocaleDateString(
            'de-DE',
            {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }
          )
        )
      })
  }, [])

  useEffect(() => {
    if (dailyNew) setDailyNew(dailyNew)
  }, [showHosp])

  return (
    <div className='index'>
      <ThemeSwitch />
      <div className='ui vertical segment'>
        <div className='title'>Cas d'infection au Sars-CoV-2 en Suisse</div>
        {chSum && <AllCases data={chSum} />}
        {tableData && <SwissCasesTable data={tableData} />}
        <div className='infectionsChart'>
          <div className='title sec'>
            Nouvelles infections confirmées par jour
          </div>
          {showAverage && (
            <div className='key'>
              <div className='entry'>
                <img src={require('images/legende_moving.png')} />
                <div className='text'>Moyenne des 7 derniers jours</div>
              </div>
            </div>
          )}
          {charts && (
            <CaseChart
              className='casechart'
              data={charts}
              prop='cases'
              aveprop='caseave'
              scaleSteps={2000}
              domain={[0, 12000]}
              showAverage
              vertflip={false}
            />
          )}
        </div>

        <div className='infectionsChart'>
          {charts && (
            <CaseChart
              className='casechart'
              data={charts}
              prop='death'
              aveprop='deathave'
              scaleSteps={25}
              domain={[0, 150]}
              showAverage={showAverage}
              vertflip
            />
          )}
          {showAverage && (
            <div className='key'>
              <div className='entry'>
                <img src={require('images/legende_movingdeath.png')} />
                <div className='text'>Moyenne des 7 derniers jours</div>
              </div>
            </div>
          )}{' '}
          <div className='title sec'>Nouveaux décès par jour</div>
        </div>
        <div className='hint'>
          Tous les cas <b>confirmés</b> sont énumérés ici. Les chiffres sont
          basés sur les informations fournies par les cantons et peuvent
          différer de ceux de l'OFSP. Le nombre de cas guéris n'est pas
          officiellement déclaré ; nous le calculons sur la base des résultats
          concernant la durée de la maladie et la proportion de cas
          légers/graves.
        </div>
        <div className='source'>
          Source: Cantons, OFSP/sbr, Interaktiv-Team / État: {date}
        </div>
      </div>
    </div>
  )
}
const Switch = ({
  isOn,
  toggle,
  labels
}: {
  isOn: boolean
  toggle: React.SetStateAction<any>
  labels: [string, string]
}) => {
  return (
    <div className='bigToggleWrapper'>
      <div className='center'>
        <div className={'label ' + (!isOn ? '' : 'off')}>{labels[0]}</div>
        <div className='toggleContainer'>
          <Toggle
            defaultChecked={isOn}
            icons={false}
            onChange={e => {
              toggle(e.target.checked)
            }}
          />
        </div>
        <div className={'label right ' + (isOn ? '' : 'off')}>{labels[1]}</div>
      </div>
    </div>
  )
}
